import { browserHistory } from 'react-router';
import invariant from 'invariant';

function changeNonReturnablePage(
  organizationId: string,
  pageNumber: number,
  entriesPerPage: number,
) {
  invariant(organizationId, 'An organization identifier is required');
  invariant(pageNumber, 'A page number is required');
  invariant(entriesPerPage, 'A page size is required');
  return browserHistory.push(`/${organizationId}/catalog/non-returnable?entriesPerPage=${encodeURIComponent(entriesPerPage)}&pageNumber=${encodeURIComponent(pageNumber)}`);
}

export default changeNonReturnablePage;
